import { inject } from 'vue';

export const useInject = <T>(key: string): T => {
  const value = inject<T>(key);
  if (!value) {
    throw new Error(`provider/service ${key} not found in injection context`);
  }
  return value as T;
};
